import { cairo0moduleConfig } from "@js/educationContent/CairoMummiesContent/cario_module0";
import { cairo1moduleConfig } from "@js/educationContent/CairoMummiesContent/cairo_module1";
import MummyHead from "@js/public/images/MummyHead.svg";
import {
    EducationSubItem,
    InputOutput,
    RunnableProgramResponse,
    EducationModuleInfo,
} from "../Interfaces/interfaces";
import { User } from "../UserProfile/types";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import StarklingsDeerLogo from "@js/public/images/StarklingsDeerLogo.svg";
import { starklingsSyntaxConfig } from "@js/educationContent/StarklingsContent/syntax/syntax_module";
import { starklingsStringConfig } from "@js/educationContent/StarklingsContent/strings/string_module";
import { starklingsStorageConfig } from "@js/educationContent/StarklingsContent/storage/storage_module";
import { starklingsImplicitArgumentsConfig } from "@js/educationContent/StarklingsContent/implicit_arguments/implicit_arguments_module";
import { starklingsRecursionConfig } from "@js/educationContent/StarklingsContent/recursion/recursion";
import { starklingsRegistersConfig } from "@js/educationContent/StarklingsContent/registers/registers";
import { starklingsRevokedReferencesConfig } from "@js/educationContent/StarklingsContent/revoked_references/revoked_references";
import { starklingsBuiltinsConfig } from "@js/educationContent/StarklingsContent/builtins/builtins";
import { starklingsTricksConfig } from "@js/educationContent/StarklingsContent/tricks/tricks";
import { starklingsHintsConfig } from "@js/educationContent/StarklingsContent/hints/hints";

import { starklings1IntroConfig } from "@js/educationContent/Starklings1.0Content/intro/intro";
import { starklings1VariablesConfig } from "@js/educationContent/Starklings1.0Content/variables/variables";
import { starklings1PrimitiveTypesConfig } from "@js/educationContent/Starklings1.0Content/primitive_types/primitive_types";
import { starklings1OperationsConfig } from "@js/educationContent/Starklings1.0Content/operations/operations";
import { starklings1IfConfig } from "@js/educationContent/Starklings1.0Content/if/if";
import { starklings1FunctionsConfig } from "@js/educationContent/Starklings1.0Content/functions/functions";
import { starklings1QuizesConfig } from "@js/educationContent/Starklings1.0Content/quizes/quizes";
import { starklings1EnumsConfig } from "@js/educationContent/Starklings1.0Content/enums/enums";
import { starklings1OptionsConfig } from "@js/educationContent/Starklings1.0Content/options/options";
import { starklings1ArraysConfig } from "@js/educationContent/Starklings1.0Content/arrays/arrays";
import { starklings1StructsConfig } from "@js/educationContent/Starklings1.0Content/structs/structs";
import { starklings1MoveSemanticsConfig } from "@js/educationContent/Starklings1.0Content/move_semantics/move_semantics";
import { starklings1TraitsConfig } from "@js/educationContent/Starklings1.0Content/traits/traits";

export interface ChallengeGroup {
    id: number;
    title: string;
    imgSrc: string;
    challengeGroupOwner: User;
    challengeGroupRecipients: User[];
    lastUpdated: number;
    created: number;
    numChallenges: number;
    alias: string;
}

export interface ChallengeGroupUI extends ChallengeGroup {
    challengeItems: Challenge[];
}

export interface Challenge {
    title: string;
    category: string;
    owner: User | null;
    id: number;
    formattedDescription: string;
    challengeGroup?: ChallengeGroup;
    ioList: InputOutput[];
    lastUpdated: number;
    created: number;
    questionType: string;
}

export interface ChallengeUserProgress {
    id: number;
    address: string;
    challengeId: number;
    codeContent: string;
    challengeResponse: RunnableProgramResponse[];
    lastUpdated: number;
    created: number;
}

export interface CairoRunResult {
    success: boolean;
    output: {
        msg: string;
        lineNumErr: number;
        colNumErr: number;
        out: string;
    };
}

export interface Course {
    courseName: string;
    title: string;
    imgSrc: string;
    path: string;
    moduleGroup: ModuleGroup[];
    courseBannerImgLeft: string;
    courseBannerImgCenter?: string;
    courseBannerImgRight: string;
    borderColorStyle?: {
        borderColor: string;
        background?: string;
        border?: string;
        borderImageSource?: string;
        borderImageSlice?: number;
        borderRadius?: string;
    };
    buttonStyle?: { color: string; backgroundColor: string };
    moduleCardBackgroundColor?: { backgroundColor: string };
    moduleCardTextColor?: { color: string };
    version?: number;
}

export interface CoursePageProps extends Course {
    allCourseProgress?: any;
}

export interface EducationModule {
    imgSrc: string;
    solution: string;
    moduleInfo: EducationModuleInfo;
    lessons: EducationSubItem[];
}

export interface ModuleGroup {
    groupName: string;
    modules: EducationModule[];
}

export const starklingsTheme = "#D4007C";
export const starklingsThemeSecondary = "#FF9D03";

export const CAIRO_MUMMIES = "cairomummies";
export const STARKLINGS = "starklings";
export const STARKLINGS1 = "starklings1";

export const COURSES_MODULE_MAP: any = {
    cairomummies: [
        "simpleCairoScriptingToBuildPyramids",
        "meetingYourFirstArray",
    ],
    starklings: [
        "starklingsSyntax",
        "starklingsStrings",
        "starklingsStorage",
        "starklingsImplicitArguments",
        "starklingsRecursion",
        "starklingsRegisters",
        "starklingsRevokedReferences",
        "starklingsBuiltins",
        "starklingsTricks",
        "starklingsHints",
    ],
    starklings1: [
        "starklings1Intro",
        "starklings1Variables",
        "starklings1PrimitiveTypes",
        "starklings1Operations",
        "starklings1If",
        "starklings1Functions",
        "starklings1Quizes",
        "starklings1Enums",
        "starklings1Options",
        "starklings1Arrays",
        "starklings1Structs",
        "starklings1MoveSemantics",
        "starklings1Traits",
    ],
};

export const EDUCATION_COURSES: Course[] = [
    {
        title: "Cairo Mummies",
        imgSrc: MummyHead.src,
        path: `education/course/${CAIRO_MUMMIES}`,
        courseName: CAIRO_MUMMIES,
        courseBannerImgLeft: "/images/MummyWalk.svg",
        courseBannerImgCenter: "/images/MummyWave.svg",
        courseBannerImgRight: "/images/MummyRawr.svg",
        moduleGroup: [
            {
                groupName: "Building Cairo Scripts",
                modules: [cairo0moduleConfig, cairo1moduleConfig],
            },
        ],
        version: 0,
    },
    {
        title: "Starklings",
        imgSrc: StarklingsLogo.src,
        borderColorStyle: { borderColor: starklingsTheme },
        buttonStyle: { color: "white", backgroundColor: starklingsTheme },
        moduleCardTextColor: { color: starklingsThemeSecondary },
        moduleCardBackgroundColor: {
            backgroundColor: `${starklingsThemeSecondary}22`,
        }, // the 22 makes the color transparent
        path: `education/course/${STARKLINGS}`,
        courseName: STARKLINGS,
        courseBannerImgLeft: "/images/StarklingsBannerImgLeft.svg",
        courseBannerImgRight: "/images/StarklingsBannerImgRight.svg",
        moduleGroup: [
            {
                groupName: "Starklings Content",
                modules: [
                    starklingsSyntaxConfig,
                    starklingsStringConfig,
                    starklingsStorageConfig,
                    starklingsImplicitArgumentsConfig,
                    starklingsRecursionConfig,
                    starklingsRegistersConfig,
                    starklingsRevokedReferencesConfig,
                    starklingsBuiltinsConfig,
                    starklingsTricksConfig,
                    starklingsHintsConfig,
                ],
            },
        ],
        version: 0,
    },
    {
        title: "Starklings 1.0",
        imgSrc: StarklingsDeerLogo.src,
        borderColorStyle: {
            borderColor: starklingsTheme,
            background:
                "linear-gradient(0deg, #2E2D2C, #2E2D2C), linear-gradient(94.22deg, #EA00FF 1.85%, #D4007C 32.44%, #FF9C05 67.04%, #FFD70F 100.76%)",
            border: "2px solid transparent",
            borderImageSource:
                "linear-gradient(94.22deg, #EA00FF 1.85%, #D4007C 32.44%, #FF9C05 67.04%, #FFD70F 100.76%)",
            borderImageSlice: 1,
            borderRadius: "5px",
        },
        buttonStyle: { color: "white", backgroundColor: starklingsTheme },
        moduleCardTextColor: { color: starklingsThemeSecondary },
        moduleCardBackgroundColor: {
            backgroundColor: `${starklingsThemeSecondary}22`,
        }, // the 22 makes the color transparent
        path: `education/course/${STARKLINGS1}`,
        courseName: STARKLINGS1,
        courseBannerImgLeft: "/images/StarklingsBannerImgLeft.svg",
        courseBannerImgRight: "/images/StarklingsBannerImgRight.svg",
        moduleGroup: [
            {
                groupName: "Starklings Content",
                modules: [
                    starklings1IntroConfig,
                    starklings1VariablesConfig,
                    starklings1PrimitiveTypesConfig,
                    starklings1OperationsConfig,
                    starklings1IfConfig,
                    starklings1FunctionsConfig,
                    starklings1QuizesConfig,
                    starklings1EnumsConfig,
                    starklings1OptionsConfig,
                    /*starklings1ArraysConfig,
                    starklings1StructsConfig,
                    starklings1MoveSemanticsConfig,
                    starklings1TraitsConfig,*/
                ],
            },
        ],
        version: 1,
    },
];

export const CAIRO_0_EDUCATION_COURSES = EDUCATION_COURSES.filter(
    (course: Course) => course.version === 0
);

export const CAIRO_1_EDUCATION_COURSES = EDUCATION_COURSES.filter(
    (course: Course) => course.version === 1
);
